import { useStores } from 'src/contexts/stores';

export default function useFeatureFlags() {
  const { FeatureFlags } = useStores();

  return FeatureFlags;
}
